<template>
  <div class="my-info-data">
    <div class="myTitle3">短信设置</div>
    <div class="openBox">
      <img loading="lazy" v-lazy="require('../../../assets/images/my/info1.png')" />
      <span>系统短信</span>
      <label>为您实时提醒平台重要通知信息</label>
      <el-switch :width="34" v-model="value" active-color="#13ce66"></el-switch>
    </div>
    <div class="openBox">
      <img loading="lazy" v-lazy="require('../../../assets/images/my/info2.png')" />
      <span>优惠短信</span>
      <label>第一时间获知活动内容，不错过任何精彩瞬间</label>
      <el-switch :width="34" v-model="value" active-color="#13ce66"></el-switch>
    </div>
    <div class="openBox">
      <img loading="lazy" v-lazy="require('../../../assets/images/my/info3.png')" />
      <span>祝福短信</span>
      <label>温馨的祝福，是{{ $t("titilName") }}感恩您一直以来的陪伴与支持</label>
      <el-switch :width="34" v-model="value" active-color="#13ce66"></el-switch>
    </div>
    <div class="button"><span class="btnConfirm">保存</span></div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      value: false,
    };
  },
};
</script>

<style lang="scss" scoped>
    @import url('../../../assets/css/common.css');
.my-info-data {
  .openBox {
    border-top: 1px solid #e8e8e8;
    line-height: 48px;
    padding: 20px 0;
    img {
      width: 48px;
      height: 48px;
    }
    span{
      font-size: 15px;
      margin-left: 15px;
    }
    label{
      color: #999;
      margin-left: 40px;
    }
    .el-switch{
      float: right;
      margin-right: 20px;
      transform:scale(1.5);
      margin-top: 15px;
    }
  }
  .button{
    border-top: 1px solid #e8e8e8;
    padding: 20px 0;
    text-align: right;
  }
}
</style>